import React, { useRef, useEffect, useState } from 'react';
import { Box, Card, CardHeader, CardContent, Typography } from '@mui/material';
import DischargedTable from './components/DischargedTable';
import { useTranslation } from 'react-i18next';

function DischargedPanel() {
  const { t } = useTranslation();
  const [selectedLocation, setSelectedLocation] = useState("");
  const tableRef = useRef(null);

  useEffect(() => {
    if (tableRef.current) {
      setTimeout(() => {
        tableRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 300);
    }
  }, [selectedLocation]);

  return (
    <Box sx={{ padding: '10px', width: '100%' }}>
      {/* Table Container */}
      <Box ref={tableRef} sx={{ width: '100%', marginTop: '20px' }}>
        <Card elevation={3} sx={{ width: "100%" }}>
          <CardHeader
            title={
              <Typography
                variant="h5"
                component="div"
                sx={{ color: "primary.main", fontWeight: "bold" }}
              >
                {t("Main.Discharged.DischargedPatients.DischargedPatients")}
              </Typography>
            }
          />
          <CardContent>
            <Box sx={{ width: "100%" }}>
              <DischargedTable
                selectedLocation={selectedLocation}
                setSelectedLocation={setSelectedLocation}
              />
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
}

export default DischargedPanel;
